import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
const mapVessel = (vessel) => {
    return {
        VesselName: vessel.VesselName,
        Imo: vessel.Imo,
        LastSyncDate: vessel.LastSyncDate ? new Date(vessel.LastSyncDate).toLocaleDateString() : "Never",
    };
};
export const VesselsStaleSync = ({ options }) => {
    const [isFetching, setIsFetching] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [vessels, setVessels] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const isLoading = !options.isReady || isFetching;
    const remainingCount = totalCount - vessels.length;
    useEffect(() => {
        if (!options.isReady) {
            setIsFetching(false);
            setErrorMessage("");
            setVessels([]);
            setTotalCount(0);
            return;
        }
        setIsFetching(true);
        setErrorMessage("");
        const params = new URLSearchParams();
        params.append("year", String(options.year));
        params.append("quarter", String(options.quarter));
        options.fleetIds.forEach((id) => params.append("fleetIds", String(id)));
        fetch(`/api/insights/vessels/stale?${params}`)
            .then((res) => {
            if (res.status === 204)
                return null;
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            if (data === null) {
                setVessels([]);
                setTotalCount(0);
                return;
            }
            setTotalCount(data.TotalCount);
            setVessels(data.Vessels.map(mapVessel));
        })
            .catch((e) => {
            console.error(e);
            setErrorMessage("Error fetching stale sync data");
        })
            .finally(() => setIsFetching(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options.isReady, options.year, options.quarter, options.fleetIds.join(",")]);
    return (_jsxs("div", { className: "card shadow h-100", children: [_jsx("h3", { className: "card-header", children: "Vessels without full data for the selected quarter" }), _jsxs("div", { className: "card-body", children: [(!options.isReady || isLoading) && (_jsxs("div", { className: "text-center py-3", children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), " Loading..."] })), options.isReady && errorMessage && (_jsx("div", { className: "alert alert-danger", role: "alert", children: errorMessage })), !isLoading && options.isReady && vessels.length > 0 && (_jsxs(_Fragment, { children: [_jsx("div", { className: "table-responsive", children: _jsxs("table", { className: "table table-sm align-middle mb-0", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Vessel" }), _jsx("th", { children: "IMO" }), _jsx("th", { className: "text-end", children: "Last Sync" })] }) }), _jsx("tbody", { children: vessels.map((vessel, index) => (_jsxs("tr", { children: [_jsx("td", { children: vessel.VesselName }), _jsx("td", { children: vessel.Imo }), _jsx("td", { className: "text-end", children: vessel.LastSyncDate })] }, `${vessel.Imo}-${index}`))) })] }) }), remainingCount > 0 && (_jsxs("p", { className: "text-muted small mt-2 mb-0", children: ["(... and ", remainingCount, " more)"] }))] })), !isLoading && options.isReady && vessels.length === 0 && (_jsx("p", { className: "text-muted mb-0", children: "No data available for this period." }))] })] }));
};
